import styled from "styled-components";

export const Box = styled.span<{ color: string }>`
  color: ${({ color }) => color};
  background-color: var(--white);
  border-radius: 2px;
  border: 1.5px solid ${({ color }) => color};
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  width: 14px;
  height: 14px;
  font-size: 9px;
`;

export const Chip = styled.span<{ color: string }>`
  padding: 3px 4px;
  border-radius: 4px;
  height: 24px;

  display: inline-flex;
  align-items: center;
  justify-content: center;

  font-size: var(--hv-fontsize-body-xs);
  font-weight: 600;
  line-height: var(--hv-lineheight-body-xs);
  letter-spacing: 0%;
  color: ${({ color }) => color};

  svg {
    path {
      fill: ${({ color }) => color};
    }

    rect {
      stroke: ${({ color }) => color};
    }
  }
`;

export const ChipsWrap = styled.span`
  flex-shrink: 0;
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const Title = styled.span`
  font-size: 14px;
  color: var(--text-secondary-1);
  max-width: 242px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  word-break: break-all;
  line-height: normal;
`;

export const Divider = styled.span`
  display: inline-block;
  width: 1px;
  height: 12px;
  background-color: var(--mono-10);
`;
